<script setup lang="ts">
import MessagePreview from './MessagePreview.vue'
import { getCustomLinks } from '@/components/ui/TextareaWithVars/utils'

import type { CampaignType } from '@/types/types'

const { t } = useI18n()
withDefaults(
  defineProps<{
    name?: string
    message: string
    rawMessage: string
    type: CampaignType
    isCropped?: boolean
    fitContent?: boolean
    rewardName?: string
  }>(),
  {
    type: 'sms' as CampaignType,
    name: '',
    isCropped: true,
    fitContent: false
  }
)

const { merchantName } = useLocalStorage()
</script>
<template>
  <div class="relative flex justify-center px-4 pt-6" :class="{ 'h-full overflow-hidden': !fitContent }">
    <BasePhone size="md" :hide-bottom="isCropped" :fit-content="fitContent">
      <div class="h-full bg-white" :class="{ 'pb-6': fitContent }">
        <template v-if="type === 'sms'">
          <div v-if="name" class="border-b-2 bg-muted py-4 text-center text-xl font-medium text-foreground">
            {{ name }}
          </div>
          <div class="mx-4 mt-4 flex flex-col gap-4">
            <div class="rounded-xl bg-indigo-500 p-4 text-white break-words">
              <MessagePreview
                :message="message"
                :reward-name="rewardName"
                :custom-links="getCustomLinks(rawMessage)"
                show-stop
              />
            </div>
          </div>
        </template>
        <template v-else-if="type === 'push'">
          <div class="mx-4 mt-4">
            <div class="flex gap-x-2 rounded-3xl bg-muted-foreground/60 p-3 text-white">
              <div class="flex flex-1 flex-col gap-y-3">
                <div class="flex items-center justify-between leading-none">
                  <div class="text-md line-clamp-1 font-medium uppercase">{{ merchantName }}</div>
                  <span class="text-xs">{{ t('global.words.now') }}</span>
                </div>
                <div class="line-clamp-3 max-w-full break-words text-sm">
                  <MessagePreview
                    :message="message"
                    :reward-name="rewardName"
                    :custom-links="getCustomLinks(rawMessage)"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </BasePhone>
  </div>
</template>
